// REACT
import { useContext, useState } from "react";

// CONTEXT
import { maincontext } from "../context/maincontext";

// COMPONENTS
import ToolHeader from "../components/common/ToolHeader"
import Upload from "../components/upload/Upload";
import UploadLogs from "../components/upload/UploadLogs";

// ASSETS
import languagePack from "../assets/languages/languagePack";

export default function UploadManager(params) {
    const { language, isAdmin } = useContext(maincontext);
    const [selectedDistributor, setSelectedDistributor] = useState(null);

    const baseUploadUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}data_entry`;
    const uploadUrl = isAdmin && selectedDistributor?.value
        ? `${baseUploadUrl}?distributor=${selectedDistributor.value}`
        : baseUploadUrl;

    const templateListUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}templates/list_report_templates`;
    const templateDownloadUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}templates/get_template`;

    return (
        <>
            <ToolHeader
                toolHeader={languagePack[language].uploadManager.title}
                icon={"upload"}
            />
            <Upload
                uploadUrl={uploadUrl}
                selectedDistributor={selectedDistributor}
                onSelectDistributor={setSelectedDistributor}
                templateFetchUrl={templateListUrl}
                templateDownloadBaseUrl={templateDownloadUrl}
            />
            <UploadLogs />
        </>
    )
}